import React from 'react';
import { Col, Row, Input, Button, Typography, Spin } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { MAINAPIURL, MAINVERSION, SYSTEMNAME } from '../appsettings';



const Authlogin = () => {

  const ApiURL = MAINAPIURL;
  const navigate = useNavigate();

  const [txtusername, setTxtUsername] = React.useState("");
  const [txtpassword, setTxtPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  function handleChange_username(event) {
    setTxtUsername(event.target.value);
  }

  function handleChange_password(event) {
    setTxtPassword(event.target.value);
  }

  function onClickLogin() {

    if (txtusername.trim() === "") {
      toast.error('Please Enter Username.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      return;
    }

    if (txtpassword.trim() === "") {
      toast.error('Please Enter Password.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      return;
    }

    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    }

    axios.post(`${ApiURL}/auth/signin`, {
      userName: txtusername.trim(),
      userPassword: txtpassword.trim()
    }, { headers: headers })
      .then(function (response) {

        if (response.status === 200) {
          var dataset = response.data;

          if (dataset["userId"] == null) {
            toast.error("Invalid User Details, User Not Found!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
          else {
            localStorage.setItem('APIURL', ApiURL);
            localStorage.setItem('AUTHCODE', dataset["accessToken"]);
            localStorage.setItem('USERID', dataset["userId"]);
            localStorage.setItem('USERDPNAME', dataset["displayName"]);
            localStorage.setItem('USERDESIGNATION', dataset["roleName"]);

            for (var i = 0; i < dataset["userRolePermissions"].length; i++) {
              if ((String(dataset["userRolePermissions"][i].perEnable).toLowerCase() === 'true') === true) {

                localStorage.setItem('USERPERMISSION_' + dataset["userRolePermissions"][i].perName, false);

              }
              else {

                localStorage.setItem('USERPERMISSION_' + dataset["userRolePermissions"][i].perName, true);

              }
            }

            navigate('/dash');
          }

        }
        else {
          toast.error(dataset["message"], {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          return;
        }

      })
      .catch(function (error) {

        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        return;

      })
      .finally(() => {
        setLoading(false);
      });
  }
  function onClickReset() {
    navigate('/updatepassword');
  }


  return (<>
      <Row style={{ height: "100vh" }}>
        <Col className="gutter-row bg-dark" xs={24} md={12} style={{ backgroundColor: '#209c96' }}>
        </Col>
        <Col className="gutter-row" xs={24} md={12} style={{ backgroundColor: '#93d5ce', paddingTop: 50 }}>
          <div style={{ maxWidth: 300, margin: "auto", padding: 10 }}>
            <Typography.Title level={3}>SYSTEM LOGIN</Typography.Title>
            <hr />
            <br />
            <Input disabled={loading} onChange={handleChange_username} placeholder="User Name" style={{ marginBottom: 20 }} disabled={loading} />

            <Input.Password
              onChange={handleChange_password}
              placeholder="Your Password"
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              disabled={loading}
            />
            <br /><br />
            <Row style={{ justifyContent: "space-between" }}>
              <Button onClick={onClickLogin} type="primary" disabled={loading} loading={loading}>Sign In</Button>
              <Button onClick={onClickReset} color="primary" variant="outlined" disabled={loading}>Reset Password</Button>
            </Row>

            <hr style={{ marginTop: 20 }} />
            <br />
            <p>{SYSTEMNAME} - Ver {MAINVERSION}</p>
            <p>Developed By : <a style={{ color: "#fff" }} href="https://dsoftmedia.com">DSM IT (PVT) LTD</a></p>
          </div>

        </Col>
      </Row>
      <ToastContainer />
  </>);
};

export default Authlogin;
